export class Link {
  name: string;
  url: string;

  constructor(link: Partial<Link>) {
    Object.assign(this, link);
  }
}
